module.exports = __webpack_public_path__ + "static/media/ky.bc2f4070.svg";